import { useEffect, useState } from 'react';
import { analyticsService } from '../analytics/AnalyticsService';
import { FEATURES } from '../common/constants';

export function useFeatureEnabled(featureFlag: FEATURES) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    (async () => {
      const isEnabled = await analyticsService.isFeatureEnabled(featureFlag);
      setEnabled(isEnabled);
    })();
  }, [featureFlag]);

  return enabled;
}
